'use strict';

const events = require('dom-events');

const utils = require('../utils.js');

function MainNav (ref) {
  this.cls = {
    itemsVisible: 'navigation-main__items--visible'
  };

  this.refs = {
    nav: '[data-ref="nav-main-' + ref + '"]',
    items: '[data-ref="' + ref + '-items"]',
    toggle: '[data-ref="' + ref + '-toggle"]'
  };
}

MainNav.prototype.onClick = function (event) {
  var toggle = utils.findTarget(this.refs.toggle, event);
  if (toggle) {
    event.preventDefault();
    var items = document.querySelector(this.refs.items);
    if (!items.className.includes(this.cls.itemsVisible)) {
      items.className = items.className.concat(' ' + this.cls.itemsVisible);
    } else {
      items.className = items.className.replace(' ' + this.cls.itemsVisible, '');
    }
  }
};

MainNav.prototype.bindEvents = function () {
  this.onClick = this.onClick.bind(this);
  events.on(document, 'click', this.onClick);
};

module.exports = MainNav;



//////////////////
// WEBPACK FOOTER
// ./_js/nav/main.js
// module id = 7
// module chunks = 0 2 4 5 6 7